import PropTypes from 'prop-types';
import {
  Box,
  Button,
  Drawer,
  IconButton,
  Typography,
  TextField,
  Alert,
  CircularProgress,
  Divider,
  Stack,
} from '@mui/material';
import Iconify from '../../components/iconify';
import { useEffect, useState } from 'react';
import {
  ADD_PARTNER,
  UPDATE_PARTNER,
} from 'src/redux/actionTypes';
import Scrollbar from 'src/components/scrollbar/Scrollbar';
import ChooseFileImage from 'src/components/Global/files/ChooseFileImage';

CreatePartnerSidebar.propTypes = {
  openSidebar: PropTypes.bool,
  onOpenSidebar: PropTypes.func,
  onCloseSidebar: PropTypes.func,
};

export default function CreatePartnerSidebar({
  openSidebar,
  onOpenSidebar,
  onCloseSidebar,
  onSubmit,
  errorApi,
  message,
  data,
  onEditSubmitted,
}) {
  const [partnerName, setPartnerName] = useState('');
  const [partnerLogo, setPartnerLogo] = useState('');
  const [partnerWebsite, setPartnerWebsite] = useState('');
  const [partnerOrder, setPartnerOrder] = useState('');
  const [error, setError] = useState();
  const [loading, setLoading] = useState(false);

  const handleSubmit = e => {
    e.preventDefault();
    setError();
    if (!partnerName || !partnerLogo) {
      setError('Name and logo are required');
      return;
    }
    setError();
    setLoading(true);
    if (!data) {
      onSubmit({
        name: partnerName,
        logo: partnerLogo,
        website: partnerWebsite,
        order: partnerOrder === '' ? 0 : parseInt(partnerOrder),
      });
    } else {
      const editedData = {
        name: partnerName,
        logo: partnerLogo,
        website: partnerWebsite,
        order: partnerOrder === '' ? 0 : parseInt(partnerOrder),
      };
      onEditSubmitted(editedData);
    }
  };

  useEffect(() => {
    setLoading(false);
    if (message?.action === ADD_PARTNER && !data) {
      setPartnerName('');
      setPartnerLogo('');
      setPartnerWebsite('');
      setPartnerOrder('');
    }
    if (message?.action === UPDATE_PARTNER) {
      setPartnerName('');
      setPartnerLogo('');
      setPartnerWebsite('');
      setPartnerOrder('');
    }
    if (data) {
      setPartnerName(data.name);
      setPartnerLogo(data.logo);
      setPartnerWebsite(data.website || '');
      setPartnerOrder(data.order !== undefined ? data.order : '');
    } else {
      setPartnerName('');
      setPartnerLogo('');
      setPartnerWebsite('');
      setPartnerOrder('');
    }
  }, [message, data]);

  useEffect(() => {
    setError(
      errorApi?.action === ADD_PARTNER ||
        errorApi?.action === UPDATE_PARTNER
        ? errorApi?.message
        : '',
    );
    setLoading(false);
  }, [errorApi]);

  return (
    <>
      <Button
        variant="contained"
        startIcon={<Iconify icon="eva:plus-fill" />}
        onClick={() => onOpenSidebar()}
      >
        New Partner
      </Button>

      <Drawer
        anchor="right"
        open={openSidebar}
        onClose={onCloseSidebar}
        PaperProps={{
          sx: { width: 350, border: 'none', overflow: 'hidden' },
        }}
      >
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          sx={{ px: 1, py: 2 }}
        >
          <Typography variant="subtitle1" sx={{ ml: 1 }}>
            {data ? 'Edit' : 'Create'} Partner
          </Typography>
          <IconButton onClick={onCloseSidebar}>
            <Iconify icon="eva:close-fill" />
          </IconButton>
        </Stack>

        {error && (
          <Alert variant="standard" severity="error" sx={{ mt: 2 }}>
            {error}
          </Alert>
        )}

        <Divider />
        <Scrollbar>
          <Stack spacing={3} sx={{ p: 3 }}>
            <TextField
              label="Name"
              value={partnerName}
              onChange={e => setPartnerName(e.target.value)}
              fullWidth
              required
            />
            <ChooseFileImage
              title="Logo"
              onSelect={setPartnerLogo}
              selected={partnerLogo}
              error={error}
            />
            <TextField
              label="Website URL"
              value={partnerWebsite}
              onChange={e => setPartnerWebsite(e.target.value)}
              fullWidth
              placeholder="https://example.com"
            />
            <TextField
              label="Order"
              type="number"
              value={partnerOrder}
              onChange={e => setPartnerOrder(e.target.value)}
              fullWidth
              helperText="Lower numbers appear first"
            />
            {!loading ? (
              <Button
                fullWidth
                size="large"
                type="submit"
                color="inherit"
                onClick={handleSubmit}
                variant="outlined"
              >
                {data ? 'Update' : 'Create'} Partner
              </Button>
            ) : (
              <Button
                fullWidth
                size="large"
                color="inherit"
                variant="outlined"
              >
                <CircularProgress color="inherit" size={20} />
                &nbsp; {data ? 'Updating' : 'Creating'} Partner
              </Button>
            )}
          </Stack>
        </Scrollbar>
      </Drawer>
    </>
  );
}
